import { render, staticRenderFns } from "./BusinessItemForm.vue?vue&type=template&id=104678f2"
import script from "./BusinessItemForm.vue?vue&type=script&lang=js"
export * from "./BusinessItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports